import { BorrowerLoanContext } from '../constants/borrowerForm';

/** Sub notes and loans created for a B-Client can't change their borrower (Broker is only locked for sub notes). */
export const isBorrowerLocked = (isSubNote: boolean, context: BorrowerLoanContext) =>
    isSubNote || context.brokerAgreementLocked;
